import React from "react";
import useStore from "../../../context/useStore";
import { FilterField, FilterGroup, FilterPanel, ListSearchForm } from "../../common/DataList";

// Critères des réorientations : mêmes clés et mêmes valeurs qu'avant
// (reorientations/search). Les sites se cochent directement (tableau des
// identifiants de sites, comme la liste « Ajouter un site » d'avant) ; aucun
// site coché = tous les sites de l'organisme.
export const definitionsReorientations = ({ ORIENTATION_STATUS = [] } = {}, organizations = [], search, fromSites = [], toSites = []) => [
  {
    name: "fromPartner",
    group: "cedant",
    label: "Organisme cédant",
    type: "select",
    size: "lg",
    firstOptionLabel: "Tous",
    options: organizations,
  },
  search.filters.fromPartner && {
    name: "fromSites",
    group: "cedant",
    label: "Sites cédants (tous si aucun sélectionné)",
    type: "multi",
    options: fromSites,
  },
  {
    name: "toPartner",
    group: "prenant",
    label: "Organisme prenant",
    type: "select",
    size: "lg",
    firstOptionLabel: "Tous",
    options: organizations.filter((o) => o.slugName != "CAF_EG"),
  },
  search.filters.toPartner && {
    name: "toSites",
    group: "prenant",
    label: "Sites prenants (tous si aucun sélectionné)",
    type: "multi",
    options: toSites,
  },
  {
    name: "status",
    group: "reorientation",
    label: "Statut de la réo.",
    type: "select",
    size: "xl",
    firstOptionLabel: "Tous",
    options: ORIENTATION_STATUS,
  },
  { name: "isFinished", group: "reorientation", label: "Afficher les réorientations terminées", type: "checkbox" },
  {
    name: "receivedBy",
    group: "reorientation",
    label: "Uniquement les réorientations qui me sont assignées",
    type: "checkbox",
  },
];

const GROUPES = [
  { id: "cedant", title: "Cédant" },
  { id: "prenant", title: "Prenant" },
  { id: "reorientation", title: "Réorientation" },
];

const ReorientationsFilters = ({
  search,
  updateSearch,
  organizations,
  fromSites,
  toSites,
  fetchReorientations,
  isLoading,
}) => {
  const [state] = useStore();
  const constants = state.constants.items || {};
  const definitions = definitionsReorientations(constants, organizations, search, fromSites, toSites).filter(Boolean);

  return (
    <ListSearchForm onSubmit={() => fetchReorientations()} aria-label="Recherche de réorientations">
      <FilterPanel
        id="reorientations-filters"
        title="Filtres"
        applyLabel="Rechercher"
        isLoading={isLoading}
      >
        {GROUPES.map((groupe) => (
          <FilterGroup key={groupe.id} title={groupe.title}>
            {definitions
              .filter((d) => d.group === groupe.id)
              .map((definition) => (
                <FilterField
                  key={definition.name}
                  definition={definition}
                  value={search.filters[definition.name]}
                  values={search.filters}
                  onChange={updateSearch}
                  onSet={(name, value) => updateSearch({ target: { name, value } })}
                />
              ))}
          </FilterGroup>
        ))}
      </FilterPanel>
    </ListSearchForm>
  );
};

export default ReorientationsFilters;
